import { IRecommendedPackagesState } from '../../types/reducers/recommendedPackages';

export const defaultState: IRecommendedPackagesState = {
  selectedPackageId: null,
  packages: [],
};
